// extracted by mini-css-extract-plugin
module.exports = {"si-status-text":"siStatusText_si-status-text__YbUDR"};